import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Início', href: '#inicio' },
  { label: 'Sobre', href: '#sobre' },
  { label: 'Áreas de Atuação', href: '#areas' },
  { label: 'Metodologia', href: '#como-funciona' },
  { label: 'Contato', href: '#contato' },
];

const WA_LINK = 'https://wa.me/5547984929295?text=Ol%C3%A1%2C%20gostaria%20de%20falar%20com%20a%20advogada.';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'backdrop-blur-sm border-b border-white/10 py-3'
          : 'bg-transparent py-5'
      }`}
      style={scrolled ? { backgroundColor: 'rgba(13, 27, 42, 0.88)' } : undefined}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a href="#inicio" onClick={(e) => handleNavClick(e, '#inicio')} className="flex items-center cursor-pointer">
          <img
            src="https://storage.readdy-site.link/project_files/a6f833be-288a-4293-8824-b6c5052e3492/b4b8213b-ed66-4309-b2fd-c488ee0b09a8_LOGO-PNG-DRA-LEIDE---Copia.png?v=e62865c8dbdfb69920e5a583c494b48b"
            alt="Leide Gonçalves Advocacia"
            className="h-[53px] w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className={`text-sm font-medium font-sans transition-colors duration-200 hover:text-burnt-peach cursor-pointer ${
                scrolled ? 'text-white/90' : 'text-white/90'
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="flex items-center gap-2 bg-burnt-peach hover:bg-burnt-peach-light text-white text-sm font-medium font-sans px-5 py-2.5 rounded-full transition-all duration-200 whitespace-nowrap ml-6"
          >
            <i className="ri-whatsapp-line text-base"></i>
            Falar pelo WhatsApp
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button
          className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer transition-colors ${scrolled ? 'text-white' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Abrir menu"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 ${menuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'} border-t border-white/10`}
        style={{ backgroundColor: 'rgba(13, 27, 42, 0.95)' }}
      >
        <div className="px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className="text-sm font-medium font-sans text-white/80 hover:text-white transition-colors cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="flex items-center justify-center gap-2 bg-burnt-peach text-white text-sm font-medium font-sans px-5 py-3 rounded-full transition-all duration-200 whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-base"></i>
            Falar pelo WhatsApp
          </a>
        </div>
      </div>
    </header>
  );
}
